import React from 'react';
import { CheckboxProps } from 'antd/es/checkbox';

import * as S from './styles';

type Props = CheckboxProps & { readOnly?: boolean };

const Checkbox: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return <S.Checkbox $readOnly={props.readOnly} {...props} />;
};

export default Checkbox;
